export interface PageCopy {
  title?: string;
  heading?: string;
  metaDescription?: string;
  name?: string;
  breadcrumb?: string;
}

export function normalizePagePath(pathname: string): string {
  return pathname.replace(/\/+$/, '').toLowerCase();
}

/** Empty CSV cells leave the page's existing copy in place. */
export function pageCopyFromRows(rows: Record<string, string>[]): ReadonlyMap<string, PageCopy> {
  return new Map(
    rows.map((row) => [
      normalizePagePath(row.path),
      {
        ...(row.title_tag && {title: row.title_tag}),
        ...(row.h1 && {heading: row.h1}),
        ...(row.meta_description && {metaDescription: row.meta_description}),
        ...(row.name && {name: row.name}),
        ...(row.breadcrumb && {breadcrumb: row.breadcrumb})
      }
    ])
  );
}
